// extracted by mini-css-extract-plugin
module.exports = {"root":"LoadingAlert_root__3U88X","content":"LoadingAlert_content__3FzrK"};